<h2 mat-dialog-title>{{ 'water-services.dialog.select-water' | translate }}</h2>

<mat-dialog-content>
  <mat-form-field class="w-full mb-4">
    <mat-label>{{ 'water-services.dialog.filter-label' | translate }}</mat-label>
    <input matInput [formControl]="searchControl" [placeholder]="'water-services.dialog.filter-placeholder' | translate" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  @if (loading()) {
    <div class="flex justify-center p-5">
      <mat-spinner diameter="40" />
    </div>
  } @else {
    @if (waters().length === 0) {
      <div class="text-center p-5 text-gray-600">
        <p>{{ 'water-services.dialog.no-waters' | translate }}</p>
      </div>
    } @else {
      <mat-selection-list [multiple]="false">
        @for (water of waters(); track water.id) {
          <mat-list-option [value]="water" (click)="selectedWater = water" [selected]="selectedWater?.id === water.id">
            <div class="flex flex-col gap-1">
              <div class="font-medium text-sm">{{ water.title }}</div>
              @if (water.countryName) {
                <div class="text-xs text-gray-600">{{ water.countryName }}</div>
              }
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
      @if (hasMore()) {
        <div class="text-center p-3 text-sm text-gray-600">
          {{ 'water-services.dialog.more-waters' | translate }}
        </div>
      }
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton (click)="cancel()">{{ 'generic.cancel' | translate }}</button>
  <button
    matButton="filled"
    (click)="confirm()"
    [disabled]="!selectedWater">
    {{ 'generic.select' | translate }}
  </button>
</mat-dialog-actions>
